import moment from 'moment/moment';

export const dateTime12 = 'DD/MMM/YYYY hh:mm A';
export const yearMonthDayFormat = 'YYYY-MM-DD';
export const dateTime12Zone = 'DD/MMM/YYYY hh:mm:ss A Z';
export const DD_SLASH_MMM_SLASH_YYYY = 'DD/MMM/YYYY';
export const DD_SLASH_MMM_SLASH_YY = 'DD/MMM/YY';
export const MMM_SPACE_YYYY = 'MMM YYYY';
export const DD_SLASH_MMM_SLASH_YYYY_HH_COLON_MM = 'DD/MMM/YYYY HH:mm';
export const YEAR_DASH_MONTH_DASH_DAY = 'YYYY-MM-DD';
export const ISO_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const defaultDateValueFormatter = value => (value ? moment(value).format(DD_SLASH_MMM_SLASH_YYYY) : '—');
export const dateValueFormatter = value => (value ? moment(value).format(DD_SLASH_MMM_SLASH_YYYY) : '');
export const parseLocalDate = value => (value ? moment(value, yearMonthDayFormat, true).toDate() : null);
